// extracted by mini-css-extract-plugin
export default {"titleText":"titleLoading-module__titleText__pQ-Mt"};